import { z } from "zod";

// QC Standard Status Enum
export const QCStatusSchema = z.enum(["active", "draft", "inactive"]);

// QC Standard Item Form Schema (for form arrays)
export const QCStandardItemFormSchema = z.object({
  id: z.string().optional(), // For existing items during edit
  title: z.string().min(1, "ກະລຸນາໃສ່ຂໍ້ຄວາມກວດສອບ"),
  description: z.string().optional().nullable(),
  orderIndex: z.number().int().min(0),
  isRequired: z.boolean().default(true),
  passCriteria: z.string().optional().nullable(),
  failCriteria: z.string().optional().nullable(),
});

// Create QC Standard Schema
export const CreateQCStandardSchema = z.object({
  name: z.string().min(1, "ກະລຸນາໃສ່ຊື່ມາດຕະຖານ QC"),
  description: z.string().optional().nullable(),
  workTypeId: z.string().min(1, "ກະລຸນາເລືອກປະເພດງານ"),
  workStage: z.string().optional().nullable(),
  departmentId: z.string().optional().nullable(),
  inspectorPositionId: z.string().optional().nullable(),
  /** ຜູ້ກວດສອບທີ່ກຳນົດເປັນຕົວບຸກຄົນ (ຫຼາຍຄົນໄດ້) */
  inspectorUserIds: z.array(z.string()).optional().default([]),
  status: QCStatusSchema.default("draft"),
  requirePhoto: z.boolean().default(false),
  requireNotesOnFail: z.boolean().default(true),
  passCriteria: z.string().optional().nullable(),
  failCriteria: z.string().optional().nullable(),
  actionOnFail: z.string().optional().nullable(),
  notifyPositionId: z.string().optional().nullable(),
  checklistId: z.string().optional().nullable(),
  kpiId: z.string().optional().nullable(),
});

export const UpdateQCStandardSchema = CreateQCStandardSchema.partial();

// Form schemas (includes items array)
export const CreateQCStandardFormSchema = CreateQCStandardSchema.extend({
  items: z.array(QCStandardItemFormSchema).optional(),
});
export type CreateQCStandardFormDTO = z.infer<
  typeof CreateQCStandardFormSchema
>;

export const UpdateQCStandardFormSchema = UpdateQCStandardSchema.extend({
  items: z.array(QCStandardItemFormSchema).optional(),
});
export type UpdateQCStandardFormDTO = z.infer<
  typeof UpdateQCStandardFormSchema
>;

// Type exports
export type QCStatus = z.infer<typeof QCStatusSchema>;
export type CreateQCStandardDTO = z.infer<typeof CreateQCStandardSchema>;
export type UpdateQCStandardDTO = z.infer<typeof UpdateQCStandardSchema>;
export type QCStandardItemFormDTO = z.infer<typeof QCStandardItemFormSchema>;
